import React from 'react';

import { Box, Text, Tooltip } from '@chakra-ui/react';

const Information = ({ title, information, mt }) => {

  return (
    <Box display="block" mt={mt ? mt : "15px"}>
      <Text
        color="#000" 
        fontWeight={700} 
        fontSize="14px"
        lineHeight="21.6px"
      >
        {title}
      </Text>
      <Tooltip
        label={information}
      >
        <Text
          color="#6B6C71" 
          fontWeight={500} 
          fontSize="14px"
          lineHeight="19.6px"
        >
          {information}
        </Text>
      </Tooltip>
    </Box>
  );
}

export default Information;